export default __webpack_public_path__ + "static/media/kompanija.6f5d9132.jpg";